import styled from 'styled-components';
import { BodyBoldS, BodyRegularS, LightButton } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

export const ReportsSetupCont = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  #PageSectionCont {
    margin-top: 0;
  }
`;

export const SectionCont = styled.div`
  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.centy};
  `}
`;

export const SearchCont = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.decy};
  `}

  input {
    width: 224px;
  }
`;

export const AddButton = styled(LightButton)`
  display: flex;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.primary[100]};

    &:hover {
      background: ${theme.colors.primary[10]}
    }
  `}
`;

export const ActionsCont = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ImportButton = styled(LightButton)`
  display: flex;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.primary[100]};

    svg {
      transform: rotate(0.5turn);

      path {
        fill: ${theme.colors.accent.blue[100]} !important;
      }
    }

    &:hover {
      background: ${theme.colors.primary[10]}
    }
  `}
`;

export const Header = styled.div`
  height: 48px;
  border-width: 1px 0px;
  border-style: solid;
  margin: 24px 0;
  display: flex;
  align-items: center;
  width: 100%;
  ${({ theme }: IThemeProvider) => `
    border-color: ${theme.colors.neutral.primary[20]};
  `}
`;

export const InfoTitle = styled(BodyRegularS)`
  margin-right: 64px;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;
export const InfoDetail = styled(BodyBoldS)`
  margin-left: 5px;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const ReportsSetupTabsCont = styled.div`
  display: flex;
  width: 100%;
  padding: 0 0 0 8px;
`;

interface IReportsSetupTab {
  active: boolean;
  theme: ITheme;
}

export const ReportsSetupTab = styled.div<IReportsSetupTab>`
  cursor: pointer;
  height: 39px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  ${({ theme, active }: IReportsSetupTab) => `
    ${
      active &&
      `
    background: ${theme.colors.neutral.primary[5]};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    border-radius: 8px 8px 0 0;
    `
    }
  `}
`;

export const TabTitle = styled(BodyBoldS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `}
`;
